import React from 'react';
import { Row, Col } from 'reactstrap';
import DriverEqipForm from './DriverEqipForm';

export class DriverEqipContent extends React.Component {
  render() {
    return (
      <div>
        <Row>
          <Col xs='12' style={{ margin: '10px auto', fontSize: 12 }}>
            <h5
              style={{
                marginTop: 5,
                marginBottom: 10,
                textAlign: 'center',
              }}
            >
              {'Driver and Eqipment Information'}
            </h5>
            <DriverEqipForm />
          </Col>
        </Row>
      </div>
    );
  }
}

export default DriverEqipContent;
